import { render, staticRenderFns } from "./TkHotelGallery.vue?vue&type=template&id=1fbbfd92&"
import script from "./TkHotelGallery.vue?vue&type=script&lang=js&"
export * from "./TkHotelGallery.vue?vue&type=script&lang=js&"
import style0 from "./TkHotelGallery.vue?vue&type=style&index=0&id=1fbbfd92&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports